import createReducer from '../lib/createReducer';
import setPayloadReducer from '../lib/setPayloadReducer';
import getPhotoSphereLoader from '../lib/mapService/getPhotoSphereLoader';
import { updateUrl } from '../lib/url';

const initialState = {
  id: '',
  isLoading: false,
  progress: 100.0,
  rotation: null,
  depthInfo: {
    canvas: getPhotoSphereLoader().canvas,
    links: [],
    tiles: [],
  },
};

const SET_ID = 'PANORAMA::SET_ID';
const SET_LOADING = 'PANORAMA::SET_LOADING';
const SET_PROGRESS = 'PANORAMA::SET_PROGRESS';
const SET_DEPTH_INFO = 'PANORAMA::SET_DEPTH_INFO';
const SET_ROTATION = 'PANORAMA::SET_ROTATION';

/**
 * Set depth info.
 * @param {!HTMLCanvas} canvas Canvas element.
 * @param {array} links Links for street navigation.
 * @param {array} tiles Images of street view.
 * @return {object} action.
 */
export const setDepthInfo = ({ canvas, links, tiles }) => ({
  type: SET_DEPTH_INFO,
  payload: {
    canvas,
    links,
    tiles,
  },
});

/**
 * Set panorama Id.
 * @param {!String} id The id of an panorama.
 * @param {bool} isUpdateUrl Should url be updated.
 * @return {object} action.
 */
export const setPanoramaId = (
    id,
    isUpdateUrl = true,
) => (dispatch, getState) => {
  dispatch({
    type: SET_ID,
    payload: { id },
  });

  if (isUpdateUrl) {
    updateUrl(getState());
  }
};

/**
 * Set altitude.
 * @param {!Bool} isLoading Is panorama loading.
 * @return {object} action.
 */
export const setLoading = (isLoading) => ({
  type: SET_LOADING,
  payload: { isLoading },
});

/**
 * Set progress.
 * @param {!Number} progress The loading progress of Panorama.
 * @return {object} action.
 */
export const setProgress = (progress) => ({
  type: SET_PROGRESS,
  payload: { progress },
});

export const setRotation = (
    rotation,
    isUpdateUrl = true,
) => (dispatch, getState) => {
  dispatch({
    type: SET_ROTATION,
    payload: {
      rotation,
    },
  });

  if (isUpdateUrl) {
    updateUrl(getState());
  }
};

const reducer = {
  [SET_DEPTH_INFO]: (state, action) => ({
    ...state,
    depthInfo: action.payload,
  }),

  [SET_ID]: setPayloadReducer,

  [SET_LOADING]: setPayloadReducer,

  [SET_PROGRESS]: setPayloadReducer,

  [SET_ROTATION]: setPayloadReducer,
};

export default createReducer(reducer, initialState);
